/**
 * Kolorme Learn Page — klp- namespaced JS
 * Filter pills, path card navigation, smooth scroll
 */
(function () {
  'use strict';
 
  /* ── Filter pills (course grid) ─────────────── */
  const filterWrap = document.querySelector('.klp-courses__filters');
  const courseGrid = document.querySelector('.klp-courses__grid');
 
  if (filterWrap && courseGrid) {
    filterWrap.addEventListener('click', function (e) {
      const pill = e.target.closest('.klp-filter-pill');
      if (!pill) return;
 
      // Update active state
      filterWrap.querySelectorAll('.klp-filter-pill').forEach(function (p) {
        p.classList.remove('klp-filter-pill--active');
        p.setAttribute('aria-selected', 'false');
      });
      pill.classList.add('klp-filter-pill--active');
      pill.setAttribute('aria-selected', 'true');
 
      var filterVal = pill.getAttribute('data-filter');
      applyFilter(filterVal);
    });
  }
 
  function applyFilter(filterVal) {
    if (!courseGrid) return;
    var cards = courseGrid.querySelectorAll('.klp-course-card');
 
    cards.forEach(function (card) {
      if (filterVal === 'all') {
        card.hidden = false;
        return;
      }
 
      var level = (card.getAttribute('data-level') || '').toLowerCase();
      var path = (card.getAttribute('data-path') || '').toLowerCase();
      var isPrivate = card.getAttribute('data-private') === 'true';
 
      var show = false;
 
      if (filterVal === 'private') {
        show = isPrivate;
      } else if (filterVal === 'group') {
        show = !isPrivate;
      } else {
        // Match on level or path
        show = level === filterVal || path === filterVal;
      }
 
      card.hidden = !show;
    });
  }
 
 
  /* ── Path cards (scroll + filter or link) ───── */
  var pathCards = document.querySelectorAll('.klp-paths__card');
 
  pathCards.forEach(function (card) {
    card.addEventListener('click', function () {
      var action = card.getAttribute('data-path-action');
 
      if (action === 'link') {
        var url = card.getAttribute('data-path-url');
        if (url) window.location.href = url;
        return;
      }
 
      // Default: scroll to course grid + activate filter
      var filterValue = card.getAttribute('data-path-target');
      if (!filterValue) return;
 
      // Activate matching filter pill
      if (filterWrap) {
        var pills = filterWrap.querySelectorAll('.klp-filter-pill');
        pills.forEach(function (p) {
          p.classList.remove('klp-filter-pill--active');
          p.setAttribute('aria-selected', 'false');
        });
 
        var matchPill = filterWrap.querySelector('[data-filter="' + filterValue + '"]');
        if (matchPill) {
          matchPill.classList.add('klp-filter-pill--active');
          matchPill.setAttribute('aria-selected', 'true');
        }
      }
 
      applyFilter(filterValue);
 
      // Smooth scroll to courses section
      var coursesSection = document.getElementById('klp-courses');
      if (coursesSection) {
        coursesSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
 
 
  /* ── Smooth scroll for anchor links ─────────── */
  document.querySelectorAll('a[href^="#klp-"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var targetId = link.getAttribute('href').slice(1);
      var target = document.getElementById(targetId);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
 
})();